// extracted by mini-css-extract-plugin
module.exports = {"policy":"Policy_policy__3Jq4b","policy__links":"Policy_policy__links__ikGMV"};